/* eslint-disable */

import { selector, selectorFamily } from 'recoil'
import { get } from '../http/restservice'
import env from '../env/env'

const UserKycStatus = selector({
  key: 'UserKycStatus',
  get: async () => {
    const url = `${env.API_URL}customerservice/api/hyperverge/checkKycInitiated`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const CustomerKycStatuses = selectorFamily({
  key: 'CustomerKycStatuses',
  get: (phoneNumber) => async () => {
    const url = `${env.API_URL}customerservice/api/customer/fetchCustomerKycStatuses?kycPhoneNumber=${phoneNumber}`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})


const PortfolioAllocation = selector({
  key: 'PortfolioAllocation',
  get: async () => {
    const url = `${env.API_URL}mutualfundservice/api/mfPortfolioData/assetAllocation`
    const response = await get(url)
    if (response.isError) {
      return []
    }
    return response
  },
})

export { UserKycStatus, CustomerKycStatuses, PortfolioAllocation }
